/**
 * pastoralIdentityResolver.js
 *
 * Detects identity drift risk and returns a corrective instruction.
 *
 * Kevia has a stable identity defined in kevia-identity.js.
 * Over long conversations or in operational contexts, the LLM can drift
 * toward motivational, therapeutic, or corporate registers.
 *
 * This module detects those conditions and injects a gentle identity anchor.
 * Does NOT re-define identity — it guards against drift.
 */

/**
 * @param {{
 *   intent:             string,
 *   mood:               string,
 *   conversationLength: number,
 * }} params
 * @returns {{ hasDriftRisk: boolean, instruction: string|null }}
 */
export function resolveIdentitySignal({ intent, mood, conversationLength }) {
  // Long conversations — highest drift risk; reinforce pastoral voice
  if (conversationLength >= 10) {
    return {
      hasDriftRisk: true,
      instruction:
        "Mantén sobriedad pastoral. No derives hacia lenguaje motivacional, terapéutico ni corporativo.",
    };
  }

  // Planning / analysis context over many turns → corporate voice risk
  if (
    conversationLength >= 6 &&
    (intent === "planning" || intent === "analysis")
  ) {
    return {
      hasDriftRisk: true,
      instruction: "Mantén voz pastoral, no gerencial.",
    };
  }

  // Prayer intent in operational framing → identity incongruence
  if (intent === "prayer" && conversationLength >= 4) {
    return {
      hasDriftRisk: false,
      instruction: "Responde desde la pastoral, no como consejería clínica.",
    };
  }

  return { hasDriftRisk: false, instruction: null };
}
